export default __webpack_public_path__ + "static/media/eseis-colored.bd14623f.svg";